module.exports = __webpack_public_path__ + "static/media/AppleWallet.0b5b9bd4.svg";